import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet';

const School = () => (
	<div className='flexContent'>
		{/*<div className="denseGrid">*/}
		<Helmet

			title="Barcelona Code School"
			meta={[
				{ name: 'description', content: 'About Barcelona Code School' },
				{ name: 'keywords', content: 'barcelona code school, barcelona coding school, bcncoding' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
			]}
		/>
		<div className='transparentContainer spanAcrossGrid flex1200'>
			<h1>We are Barcelona Code School</h1>
		</div>

		<div className='transparentContainer'>
			<article className='whiteCard spanAcrossGrid'>
				<p>Barcelona Code School is one of the top-ranked code schools highly regarded both by students for in-depth personalized learning, supporting environment, knowledgable professional instructors and by companies for preparing job-ready developers and designers fully ready to be employed.</p>
				<p>We are a boutique founder-led school focused on the quality of training and success of each student. From the beginning we decided to keep the groups small, up to 6 people, to have a chance to work with each student individually. We were never about crunching numbers but about quality of this life-changing experience.</p>
				<p>Our approach for all teh courses and bootcamps is the same - focusing on teaching practical and fundamental understanding of skills and methods to ensure that no matter which tools are current our graduates have enough knowledge to adopt them. We are not "teaching react" or "teaching Figma", but instead we teach "front-end development" or "UX/UI design".</p>

				<p>The tools they come and go, but the skills remain.</p>

				<p>Our main expertise lays within web/mobile development, UX/UI Design, Game Development, and AI Engineering.</p>

				<p>The immersive <a href='/barcelona-code-school/javascript-full-stack-bootcamp/'>full-stack training</a> on web and mobile development is aimed at preparing  software engineers. Combined with the job support we offer the bootcamp is a powerful springboard into starting a new career which helped hundreds of our graduates to get into tech and change their lives for the better. </p>

				<p>If your plan is to break into the videogames industry we offer the <a href='/game-development-bootcamp/'>Game Development Bootcamp</a> with Unity and C# and up to 11 games included into the curriculum plus a free personal project. By the end of it you will be prepared to start working as a junior game developer or go indie and create your own prototypes.</p>

				<p>Another track we offer is <a href='/machine-learning-and-ai-engineering-bootcamp/'>Deep Learning and AI development engineering bootcamp</a>. Designed for the students willing to enter the Deep Learning field with skills such as Deep Learning, Neural Networks and AI development.</p>

				<p>For entering the AI Agents Automation job market in a quick and systemized way, the <a href='/ai-business-automation-architect/'>AI Agent & Automation Bootcamp</a> provides the necessary knowledge and hands-on experience.</p>

				<p>For those looking for a career in tech which doesn't involve coding we offer the <a href='/ux-design-bootcamp-in-barcelona-code-school/'>UX/UI Design Bootcamp</a> to enter the fascinating field of User Experience Design.</p>

				<p>Thanks to our top-notch curriculum and one of the best student/mentors ratios we achieve truly in-depth learning experience and succeed in preparing students for a job-ready level in 9 weeks of full-time training.</p>

				{/*online training*/}

				{/*all the scholarships*/}
				<p>Since the very start in 2015 we carry on the “Women in Tech” scholarship and supporting underrepresented groups through numerous collaborations and partnerships.</p>
			</article>
		</div>


		{/*<h1>This is our campus</h1>
<Campus />*/}






		{/*<article className='transparentContainer '>
<h2>Matej Murín</h2>
<h2>Developer</h2>
<div className='whiteCard'>
<img className='offsetImage' style={{    
width: '40%',
float: 'left',
margin: '0 1em 1em 0'}}
src={Matej}/>

<p>Matej is a passionate and skilled software developer prolific in React.js, React Native, NodeJS, Mongo, Python, Docker.</p> 
<p>His teaching experience in learn2code.sk and developer's experience in companies like thinkcreatix, yeself, profit365 give Matej a perfect combination of real-life devs skills and understanding of teaching process.</p>
<p>Team: Kids courses</p>
<div className='cleaner'/>
</div>
</article>*/}
	</div>
)

export default School
